import React from "react";
import { Row, Col } from "react-bootstrap";

function Experience() {
  const experiences = [
    {
      company: "Pixel-Square",
      role: "Software Developer",
      location: "Germany",
      period: "June 2025 — Present",
      points: [
        "Independently architected and shipped 3 client products end-to-end — from system design and full-stack development to deployment and live production operations — as an early engineer at a German software startup.",
        "Architected and shipped Schul.software, a multi-tenant school management SaaS, from zero to live production — now serving 3 schools and 50–100 students and staff — with strict data isolation, per-school subdomain routing, and JWT-based authentication across 4 user roles (admin, teacher, parent, student).",
        "Eliminated hours of weekly Excel-based manual scheduling by designing a timetable engine with automated conflict resolution, teacher availability management, and substitute tracking — replacing spreadsheet workflows entirely.",
        "Launched a live multi-vendor marketplace with multiple companies onboarded, integrating independent vendor storefronts, platform commission splits, and automated vendor payout reconciliation via Stripe Connect.",
        "Built a RAG pipeline using semantic search and Mistral AI embeddings, grounding LLM outputs in project-specific context to auto-generate structured development tickets from natural language input.",
        "Built and maintained CI/CD pipelines via GitHub Actions and automated production operations — DNS, SSL certificates, and subdomain routing via Cloudflare — across all 3 projects, eliminating manual deployment and maintenance overhead.",
        "Established full production observability from scratch using Uptime Kuma and Sentry, cutting error detection time from hours to minutes across all live client environments.",
      ],
    },
    {
      company: "Aurora Solutions",
      role: "Software Engineer",
      location: "Sweden",
      period: "July 2023 — April 2025",
      points: [
        "Drove sprint planning, code reviews, and cross-functional technical discussions within an international agile team of 5–10 engineers, shipping production-ready features consistently across multiple release cycles.",
        "Built Cell Operative, a live employee management platform, with accessible, responsive UI components in Next.js and Tailwind CSS, real-time bidirectional updates via WebSockets, and authentication via NextAuth.js — covering task creation and assignment, shift management, and employee tracking, stress-tested to 1,000+ concurrent tasks with no degradation in production.",
        "Launched Stakater Cloud MVP to beta, leading frontend development and improving Golang backend performance, reliability, and scalability, while contributing to REST API design and frontend-backend integration under live beta traffic.",
        "Executed structured test procedures during beta, identifying and resolving stability issues to harden the platform ahead of full production release.",
        "Improved application reliability and reduced query response times by approx. 30% through PostgreSQL query optimization, caching strategies, and load testing.",
      ],
    },
    {
      company: "ZUNTECH",
      role: "React Developer Intern",
      location: "Pakistan",
      period: "Feb 2023 — Jun 2023",
      points: [
        "Built and maintained responsive React.js UI components using Tailwind CSS, contributing to production-ready features across the development lifecycle.",
        "Translated Figma design mockups for Al-Shifa Hospital into pixel-perfect, responsive React components, ensuring cross-browser compatibility and mobile responsiveness.",
        "Collaborated with senior developers through code reviews, gaining hands-on experience with component architecture, state management, and agile workflows.",
      ],
    },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
      <Col md={10}>
        {experiences.map((exp, index) => (
          <div key={index} className="resume" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <div className="resume-item">
              <h4 style={{ color: "#c770f0", fontWeight: 600 }}>
                {exp.company}
              </h4>
              <p style={{ fontStyle: "italic", marginBottom: "4px" }}>
                {exp.role} &nbsp;|&nbsp; {exp.location}
              </p>
              <p style={{ color: "#a588c0", fontSize: "0.9em", marginBottom: "10px" }}>
                {exp.period}
              </p>
              <ul>
                {exp.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </Col>
    </Row>
  );
}

export default Experience;